var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"cart-widget",attrs:{"to":"/korzina"}},[_c('SvgIcon',{staticClass:"cart-widget__ico",attrs:{"name":"cart","width":"26","height":"22"}}),_c('div',{staticClass:"cart-widget__count"},[_c('div',{staticClass:"cart-widget__count-num"},[_vm._v("0")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }